import { setAttr, setStyle, mount, unmount } from 'redom';

export default class Element {
  /**
   * NOTICE: Root element is a redom instance
   */
  rootElement;

  attrs;
  visible; // FIXME. por default visible a true, pero y si inicia con un hide el dom element?, ajustar en el element al momento de crear la instancia ¿ ?
  children;
  parent;
  id;

  constructor(attrs) {
    this.attrs = attrs;
    this.visible = true;
    this.children = [];
    this.parent = null;
    this.id;
  }

  getRootElement() {
    return this.rootElement;
  }

  setAttrs(attrs, skipId) {
    if (attrs === Object(attrs)) {

      if (!this.attrs) {
        this.attrs = {};
      }

      let nattrs = { ...this.attrs, ...attrs };
      this.attrs = Object.assign({}, nattrs);
      nattrs = null;

      setAttr(this.getRootElement(), attrs);

      // Seek and set id
      if (!skipId) {
        for (let at in attrs) {
          if (attrs[at] === 'id') {
            this.id = attrs[at];
            break;
          }
        }
      }
    }
  }

  removeClassName(className) {
    if (this.rootElement) {
      this.getRootElement().classList.remove(className);
    }
  }

  addClassName(className) {
    if (this.rootElement) {
      this.getRootElement().classList.add(className);
    }
  }

  setStyle(style) {
    if (style === Object(style)) {
      setStyle(this.getRootElement(), style);
    }
  }

  setText(text) {
    this.getRootElement().textContent = text;
  }

  getAttrs() {
    return this.attrs;
  }

  setId(id) {
    this.id = id;
    this.setAttrs({ id }, true);
  }

  getId() {
    return this.id;
  }

  isVisible() {
    return this.visible;
  }

  show() {
    this.setStyle({ display: null });
    this.visible = true;
  }

  hide() {
    this.setStyle({ display: 'none' });
    this.visible = true;
  }

  destroyParentReference() {
    let i;
    let childrenOfParent;
    if (this.parent && Array.isArray(this.parent.children) && this.parent.children.length > 0) {
      childrenOfParent = this.parent.children;
      for (i = childrenOfParent.length - 1; i >= 0; i--) {
        if (this === childrenOfParent[i]) {
          childrenOfParent.splice(i, 1);
        }
      }
    }
  }

  // FIXME. Esto destruye automáticamente los hijos? si los hubiera?
  destroy() {
    this.unmount();
    // Bien borrado po favo:
    delete this.rootElement;
  }

  unmount() {
    this.destroyParentReference();
    if (this.parent) {
      unmount(this.parent.getRootElement(), this.getRootElement());
    }
  }

  setParent(parent) {
    this.parent = parent;
  }

  getParent() {
    return this.parent;
  }

  addChild(childObj) {
    const id = childObj.getId();
    if (id) {
      if (typeof this.children[id] !== 'undefined') {
        throw ("AAF DOM Element when addChild - duplicated id: " + id);
      }
    }
    this.children.push(childObj);
    if (typeof childObj.setParent === 'function') {
      childObj.setParent(this);
    }
    mount(this.getRootElement(), childObj.getRootElement());

    return this;
  }
}



// WEBPACK FOOTER //
// ./src/AAF/lib/gui/dom/Element.js